/**
 * @(#)2019/6/17.
 * YxKindEditor，富文本编辑器
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import React from "react";
// import './assets/qs.min.js'
import { message } from "antd";
import "./assets/lang/zh-CN.js";
import "./assets/kindeditor-config.js";
import { get, merge } from "../../../utils";
import config from "../../../config/index.js";
import { l } from "../../../config/language/index.js";

const { Component } = React;

export default class extends Component {
  // 构造函数
  constructor(props, context) {
    super(props, context);
    this.editItem = null;

    this.state = {
      visible: false,
      frameWidth: 0,
    };
    this.uploadFile = null;
    this.disable = get(this.props, "disable", false) === true;
  }

  async componentDidMount() {
    const change = get(this.props, "change", () => {});
    const props = { ...this.props, change };
    this.initEditor(props);
    this.editItem.readonly(this.disable);
    const load = get(this.props, "load", () => {});
    load({ editItem: this.editItem });
  }

  // 已加载组件，收到新属性时调用
  componentWillReceiveProps(nextProps) {
    if (this.editItem && this.editItem.html() != nextProps.html) {
      let html = nextProps.html == undefined ? "" : nextProps.html;
      this.editItem && this.editItem.html(html);
    }
    if (nextProps.disable !== this.disable) {
      this.disable = nextProps.disable === true;
      console.log("bukexue", nextProps, this.disable);
      this.editItem.readonly(this.disable);
    }
  }

  hideDialog() {
    try {
      this.editItem.hideDialog();
    } catch (error) {
      console.warn("没有展开就隐藏");
    }
  }

  // 区分富文本的图片 与 视频类型
  checkType(fielType, attachType) {
    if (attachType === "image") {
      const re = new RegExp("image*");
      if (!re.test(fielType)) {
        message.error(l("Editor.rusm", this));
        return false;
      }
    } else if (attachType === "media") {
      const re = new RegExp("video*");
      if (!re.test(fielType)) {
        message.error(l("Editor.upMedia", this));
        return false;
      }
    }
    return true;
  }

  uploadFileAction = async (files, insert, attachType) => {
    const file = get(files, "[0]");
    const fielType = get(file, "type", null);

    if (!this.checkType(fielType, attachType)) {
      this.hideDialog.call(this);
      return;
    }

    const uploadFile = get(this.props, "uploadFile", null);
    if (uploadFile != null) {
      if (uploadFile.uploadRules(file)) {
        let imgUrl = await uploadFile.uploadFile(file).catch((err) => {
          console.log("上传失败", err);
          message.error(l("Editor.uem", this));
        });
        if (typeof imgUrl === "string" && imgUrl.includes("http")) {
          message.success(l("Editor.usm", this));
          insert(imgUrl);
        } else if (get(imgUrl, "url", "").includes("http")) {
          message.success(l("Editor.usm", this));
          insert(get(imgUrl, "url", ""));
        }
      }
      // this.hideDialog.call(this)
    } else {
      // setTimeout(this.hideDialog.bind(this), 300)
    }
  };

  // 修复KindEditor 在有groupKey时 id包含. 导致kindEditor 渲染出错的问题
  handleDomId = (props) => {
    const _id = get(props, "id", null);
    const domId = (_id.indexOf(".") > -1 && _id.replace(".", "_")) || _id;
    return domId;
  };

  initEditor = (props) => {
    const editorParam = get(this.props, "editorParam", {});
    const languageDict = {
      enUS: "en",
      zhCN: "zh-CN",
    };
    var customConfig = {
      langType: languageDict[config.languageEnv],
      uploadJson: "http://www.dtyunx.com",
      resizeType: 0,
      allowFileManager: false,
      allowFlashUpload: true,
      allowMediaUpload: true,
      allowFileUpload: false,
      maximumWords: 10,
      afterChange: () => {
        if (this.editItem) {
          console.log(
            "字数",
            this.editItem.count("text"),
            this.editItem.html()
          );
          console.log(
            "字数",
            this.editItem.count("text"),
            this.editItem.html()
          );
          get(this, "props.inputChange", () => {})(this.editItem.html());
          get(this, "props.change", () => {})(
            this.editItem.html(),
            this.handleDomId(this.props)
          );
        }
      },
      cssData: "img {max-width:100%; }",
      items: KIND_EDITOR_ITEMS_CONFIG,
      // 自定义上传
      customUploadImg: this.uploadFileAction,
      afterCreate: function () {
        let that = this;
        that.sync();
      },
      beforeSetHtml: function () {
        let that = this;
        that.sync();
      },
      afterSetHtml: function () {
        console.log("afterSetHtml");
        let that = this;
        that.sync();
      },
      afterBlur: function () {
        let that = this;
        that.sync();
      },
    };
    this.editItem = KindEditor.create(
      `#${this.handleDomId(this.props)}`,
      merge(customConfig, editorParam)
    );
    this.editItem.html(this.props.html);
  };

  // 初始状态或状态变化会触发render
  render() {
    let customStyle = this.props.style || { width: "100%", height: 400 };
    return (
      <div>
        <script
          id={this.handleDomId(this.props)}
          name={this.handleDomId(this.props) + "myContent"}
          type="text/plain"
          style={customStyle}
        ></script>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/KindEditor/Editor.js